
import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil';

// components 
import Title from '@/components/onepager/sections/Title'
import MultiShortTextDisplay from '@/components/onepager/sections/_multishorttext/display'

function MultiShortText({ id, contentID, sectionData, wrapperId }) {

  return (
    <div>
      <Title id={id} title={sectionData.title} prompt={sectionData.prompt} wrapperId={wrapperId} />

      <div className="boxBody">

        {/* {JSON.stringify(sectionData.data)} */}

        {sectionData.data.map((question, index) => (
          <div key={index} className="mb-8">
            <MultiShortTextDisplay id={contentID} sectionData={question} index={index} />
          </div>
        ))}

      </div>

    </div>
  )
}

export default MultiShortText;